export default {
    getSessionInformation: function () {
        return JSON.parse(window.$gwtBridge.getSessionInformation());
    },
    getConfigurations: function () {
        return JSON.parse(window.$gwtBridge.getConfigurations());
    },
    getWorkplaces: function () {
        return JSON.parse(window.$gwtBridge.getWorkplaces());
    },
    getWorkplacesByProfile: function () {
        return JSON.parse(window.$gwtBridge.getWorkplacesByProfile());
    },
    getDepartments: function () {
        return JSON.parse(window.$gwtBridge.getDepartments());
    },
    getDepartmentsByProfile: function () {
        return JSON.parse(window.$gwtBridge.getDepartmentsByProfile());
    },
    getProjects: function () {
        return JSON.parse(window.$gwtBridge.getProjects());
    },
    getCalendars: function () {
        return JSON.parse(window.$gwtBridge.getCalendars());
    },
    getSessionProfile: function () {
        return JSON.parse(window.$gwtBridge.getSessionProfile());
    },
    newCompany: function () {
        return JSON.parse(window.$gwtBridge.newCompany());
    },
    setSessionCompany: function (company) {
        return window.$gwtBridge.setSessionCompany(company);
    },
    downloadFile: function (url, fileName) {
        window.$gwtBridge.downloadFile(url, fileName);
    },
    emulateCompany: function (companyId) {
        window.$gwtBridge.emulateCompany(companyId);
    },
	////////////////////////////////////////////////////////////////////////////
	// VALIDATION UTILS
    validateRange: function (value, minimum, maximum) {
		return window.$gwtBridge.validateRange(value, minimum, maximum);
	},
	validateCIFOrDNI: function (countryId, value) {
		return window.$gwtBridge.validateCIFOrDNI(countryId, value);
	},
	validatePhone: function (countryId, value) {
		return window.$gwtBridge.validatePhone(countryId, value);
	},
	validatePostalCode: function (countryId, value) {
		return window.$gwtBridge.validatePostalCode(countryId, value);
	},
    validateDecimalSeparator: function (value, locale) {
        return window.$gwtBridge.validateDecimalSeparator(value, locale);
    },
    
	////////////////////////////////////////////////////////////////////////////
	// COMPANY UTILS
	getCompanyPlaceholderNif: function (countryId) {
		return window.$gwtCompanyUtils.getPlaceholderNifcountryId(countryId);
	},
	getCompanyPlaceholderCif: function (countryId) {
		return window.$gwtCompanyUtils.getPlaceholderCif(countryId);
	},
	getCompanyPlaceholderTelf: function (countryId) {
		return window.$gwtCompanyUtils.getPlaceholderTelf(countryId);
	},
	getCompanyPlaceholderCp: function (countryId) {
		return window.$gwtCompanyUtils.getPlaceholderCp(countryId);
	},
	////////////////////////////////////////////////////////////////////////////
    processEvent(mode, type, action, payload) {
        window.$gwtBridge.processEvent(mode, type, action, payload);
    },
    showGlobalFilter(show) {
        window.$gwtBridge.showGlobalFilter(show);
    },
    fireEvent(event, payload) {
        window.$gwtBridge.fireEvent(event, payload);
    },
}